<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                    :placeholder="$t('program_lists.name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours --> </b-col
            ><b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('program_lists.num_of_study_hours')"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="newItem.num_of_study_hours"
                  type="number"
                  :placeholder="$t('program_lists.num_of_study_hours')"
                />
              </b-form-group>
              <!-- .num_of_direct_sessions_hours --> </b-col
            > <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('program_lists.num_of_pass_exams')"
                label-for="input-4"
              >
                <b-form-input
                  id="input-4"
                  v-model="newItem.num_of_pass_exams"
                  type="number"
                  :placeholder="$t('program_lists.num_of_pass_exams')"
                />
              </b-form-group>
              <!-- .pass_percent --> </b-col
            ><b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('program_lists.pass_percent')"
                label-for="input-5"
              >
                <b-form-input
                  id="input-5"
                  v-model="newItem.pass_percent"
                  type="number"
                  :placeholder="$t('program_lists.pass_percent')"
                />
              </b-form-group>
              <!-- .clemency_percent -->
            </b-col>
               <b-col lg="3">
              <b-form-group
                id="input-group-7"
                :label="$t('program_lists.retest')"
                label-for="input-7"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  switch
                  v-model="newItem.retest"
                  value="1"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
              <b-col lg="3">
              <b-form-group
                id="input-group-7"
                :label="$t('program_lists.certificate_automatically')"
                label-for="input-7"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  switch
                  v-model="newItem.certificate_automatically"
                  value="1"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />
          <b-row>
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.Precipitate')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Precipitate"
                  vid="Precipitate"
                  rules="required"
                >
                  <b-row>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Precipitate.from"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.from')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Precipitate.to"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.to')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                  </b-row>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours -->
            </b-col>
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.Acceptable')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="acceptable"
                  vid="acceptable"
                  rules="required"
                >
                  <b-row>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Acceptable.from"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.from')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Acceptable.to"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.to')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                  </b-row>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours -->
            </b-col>
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.Good')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Good"
                  vid="Good"
                  rules="required"
                >
                  <b-row>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Good.from"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.from')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Good.to"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.to')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                  </b-row>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours -->
            </b-col>
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.highGood')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="highGood"
                  vid="highGood"
                  rules="required"
                >
                  <b-row>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.highGood.from"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.from')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.highGood.to"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.to')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                  </b-row>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours -->
            </b-col>
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.Excellence')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Excellence"
                  vid="Excellence"
                  rules="required"
                >
                  <b-row>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Excellence.from"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.from')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                    <b-col lg="6">
                      <b-form-input
                        id="input-1"
                        v-model="newItem.grade_table.Excellence.to"
                        :state="errors.length > 0 ? false : null"
                        type="number"
                        :placeholder="$t('program_lists.to')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-col>
                  </b-row>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/Program_listsController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  name: "ProgramListsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
    };
  },
  created() {
    this.newItem.grade_table = {
      Good: { to: 70, from: 60 },
      highGood: { to: 80, from: 70 },
      Acceptable: { to: 60, from: 40 },
      Excellence: { to: 100, from: 80 },
      Precipitate: { to: 40, from: 0 },
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.is_course = 1;
      if (!this.newItem.retest) this.newItem.retest = 0;
      if (!this.newItem.certificate_automatically) this.newItem.certificate_automatically = 0;
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
  watch: {
    newItem() {
      if (!this.newItem.id) {
        this.newItem.grade_table = {
          Good: { to: 70, from: 60 },
          highGood: { to: 80, from: 70 },
          Acceptable: { to: 60, from: 40 },
          Excellence: { to: 100, from: 80 },
          Precipitate: { to: 40, from: 0 },
        };
      }
    },
  },
};
</script>
